import { render } from "./Season.vue?vue&type=template&id=525b00b8"
import script from "./Season.vue?vue&type=script&lang=js"
export * from "./Season.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__